<div *ngIf="headerHide" class="unsupported-browsers-header"></div>
<div
  #staticModal="bs-modal"
  *ngIf="headerHide"
  [config]="{ backdrop: 'static', keyboard: false, animated: false }"
  bsModal
  class="unsupported-browser-bsModal modal fade"
  role="dialog"
  tabindex="-1"
>
  <div class="modal-dialog unsupported-browser-model" role="document">
    <div class="modal-content">
      <div
        aria-labelledby="unsupported-browser-title"
        class="unsupported-browsers"
        tabindex="0"
      >
        <h4 class="unsupported-browser-title" id="unsupported-browser-title">
          {{ unsupportedbrowser?.heading }}
        </h4>
        <div class="unsupported-browser-title-underline"></div>
        <div class="upgrade-better-experience">
          <p class="upgrade-better-exp">{{ unsupportedbrowser?.title }}</p>
          <p class="upgrade-your-browser">
            {{ unsupportedbrowser?.browserDescription }}
          </p>
        </div>
        <div class="unsupported-browsers-icons">
          <div *ngIf="unsupportedbrowser" class="unsupported-browsers-cond">
            <div
              *ngFor="let unsupbrowser of unsupportedbrowser.browserIconValues"
              [ngClass]="[unsupbrowser.iconText + '-container' | lowercase]"
            >
              <a
                [attr.href]="
                  unsupbrowser.browserIconLink
                    ? unsupbrowser.browserIconLink
                    : '#'
                "
                [attr.target]="
                  unsupbrowser.browserIconTarget === 'true' ? '_blank' : '_self'
                "
              >
                <img
                  [attr.alt]="unsupbrowser.iconText"
                  [attr.srcset]="unsupbrowser.browserIconLogo"
                  [ngClass]="[unsupbrowser.iconText + '-img' | lowercase]"
                />
                <div
                  class="unsupported-label"
                  [ngClass]="[unsupbrowser.iconText + '-label' | lowercase]"
                >
                  {{ unsupbrowser.iconText }}
                </div>
                <span class="sr-only">Link opens in a new tab</span>
              </a>
            </div>
          </div>
        </div>
        <div class="row dont-care-upgrade-container">
          <div
            class="col-12 col-sm-12 ol-md-12 col-lg-6 col-xl-6 dont-care-upgrade-text"
          >
            <p>{{ unsupportedbrowser?.disclaimerText }}</p>
          </div>
          <div
            class="col-12 col-sm-12 ol-md-12 col-lg-6 col-xl-6 text-right dont-care-upgrade-button"
          >
            <button
              (click)="unSupportedBrowserclose()"
              class="btn continue"
              type="button"
            >
              {{ unsupportedbrowser?.ctaLabel }}
            </button>
          </div>
        </div>
        <div class="browser-longer-support">
          <button
            (click)="todayModenBrowser()"
            [attr.aria-expanded]="todayModenBrowserText"
            [ngClass]="{
              'browser-down-arrow-icon': todayModenBrowserText,
              'browser-up-arrow-icon': !todayModenBrowserText
            }"
            aria-describedby="today-moden-browser"
            type="button"
          >
            {{ unsupportedbrowser?.footnoteTitle }}
          </button>
        </div>
        <div
          *ngIf="todayModenBrowserText"
          class="today-moden-browser"
          id="today-moden-browser"
          innerHTML="{{ unsupportedbrowser?.footnoteDescription }}"
        ></div>
      </div>
    </div>
  </div>
</div>
